import { render } from "./BannerAds.vue?vue&type=template&id=6c9eea46"
import script from "./BannerAds.vue?vue&type=script&lang=js"
export * from "./BannerAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__